import { FC } from "react";
import { Flex, Heading } from "@chakra-ui/react";
import { Trans } from "~/utils/i18next";

export const PartnerTitle: FC = () => {
  return (
    <Flex justify="center" w="full">
      <Heading
        fontWeight="normal"
        lineHeight={{ base: "1.4", md: "1.2" }}
        textAlign="center"
        variant="th-h4"
      >
        <Trans i18nKey="onboarding.welcomeNamePage.partner.heading" />
      </Heading>
    </Flex>
  );
};
